export const DbSettingsKeys = {
  EntityIds: 'entityWujiIds',
  Original: 'originalSchema',
  Clipper: 'clipperSchema',
  Default: 'defaultSchema'
};
export const DbSettingsClipperKeys = {
  Clippers: 'clippers'
};
export var IVersionControl;
(function (IVersionControl) {
  IVersionControl[IVersionControl["Origin"] = 0] = "Origin";
  IVersionControl[IVersionControl["Row"] = 1] = "Row";
})(IVersionControl || (IVersionControl = {}));
//# sourceMappingURL=ICollection.js.map
